import { defineStore } from "pinia";
export const useJtwStore = defineStore("storeGlobal", {
  state: () => {
    return {
      token: "",
      id: 0,
      user: {},
    };
  },
  actions: {
    setToken(token, user) {
      this.token = token;
      this.user = user;
    },
  },
  persist: true,
});
